// extracted by mini-css-extract-plugin
export var button = "_ld-2";
export var card = "_ld-0";
export var closeButtonContainer = "_ld-3";
export var iconContainer = "_ld-1";